module.exports = __webpack_public_path__ + "img/column-options.f4ad9aa0.svg";